import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Config from './index';
import MobileConfig from './MobileConfig';

const ResponsiveConfig = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileConfig />}
      desktop={<Config />}
    />
  );
};

export default ResponsiveConfig;